import { render } from "./Account.vue?vue&type=template&id=746c0b57&scoped=true"
import script from "./Account.vue?vue&type=script&lang=js"
export * from "./Account.vue?vue&type=script&lang=js"

import "./Account.vue?vue&type=style&index=0&id=746c0b57&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-746c0b57"

export default script